var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-enter-cta-btn-arrow"},[_c('div',{staticClass:"c-enter-cta-btn-arrow__center"},[_c('shared-animated-icon-arrow',{attrs:{"is-dark":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }